module.exports = __webpack_public_path__ + "static/media/routes.9fae231e.svg";